import React, { useCallback, useEffect, useRef, useState } from 'react'
import requestApi from '../../utils/request'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import TableListing from '../../components/TableListing/TableListing'
import Pagination from '../../components/Pagination'
import { createColumnHelper, getCoreRowModel, getSortedRowModel, useReactTable } from '@tanstack/react-table'
import DeleteModal from '../../components/DeleteModal/DeleteModal'
import { useForm } from 'react-hook-form'
import { ReactComponent as IconsDots } from '../../assets/images/icons/icon-action-dots.svg'
import { ReactComponent as IconEdit } from '../../assets/images/icons/icon-edit-white.svg'
import { ReactComponent as IconDelete } from '../../assets/images/icons/icon-delete-white.svg'
import { ReactComponent as IconRejected } from '../../assets/images/icons/icon-rejected-status.svg'
import { ReactComponent as IconApproveRight } from '../../assets/images/icons/icon-right-aprrove.svg'
import { ReactComponent as IconDesapproveClose } from '../../assets/images/icons/icon-close-desaprrove.svg'
import ApproveDeclinePopup from '../../components/ApproveDeclinePopup/ApproveDeclinePopup'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import TableSkeleton from '../../components/TableSkeleton/TableSkeleton'
import StatusDropDown from '../../components/StatusDropDown/StatusDropDown'
import NoRecordFound from '../../components/NoRecordFound/NoRecordFound'
import AddEditModal from '../../components/AddEditModal/AddEditModal'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import InputControl from '../../components/InputControl'

const validationSchemaForType = yup.object({
      materialName: yup.string().required("Please enter material name")
         });

const MaterialManagement = () => {

    const options = ['Pending', 'Active', 'InActive', 'Decline']
    const [selectedOption, setSelectedOption] = useState('')

    const handleDropdownSelect = (option) => {
        setSelectedOption(option)
        if(selectedOption ==="All" || selectedOption)
        {
            setCurrentPage(1)
        }
    }

    const navigate= useNavigate()

  const [DataLimit, setDataLimit] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchKeyword, setSearchKeyword] = useState('');
  const [sorting, setSorting] = useState([])
  const [filter, setFilter] = useState(null)
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [deleteId, setDelteId] = useState("")
  const [ShowMaterialStatusPopup,setShowMaterialStatusPopup]= useState(false)
  const queryClient = useQueryClient()
  const EditDataRef = useRef(null);
  const[statusUpdate,setStatusUpdate] =useState(null)
  const [buttonText, setButtonText]=useState("")

  const { register, handleSubmit } = useForm()

  const handleDeleteModal = (id) => {
    setIsDeleteModal(true);
    setDelteId(id)
  }

  const handleSearch = useCallback((e) => {
    setCurrentPage(1)
    const getData = setTimeout(() => {
      setSearchKeyword(e.target.value);
    }, 1000)
    clearInterval()
  }, [])

  const handleChangePage = useCallback(
    (currentPage) => {
      setCurrentPage(currentPage);
    },
    [currentPage]
  );


  useEffect(()=>{
    setCurrentPage(1)
 },[searchKeyword])

  const handleChange = (eventkey) => {
    setDataLimit(eventkey);
  }


  function handleDelete(materialId) {
    mutationDelete.mutate(materialId)
    setIsDeleteModal(false);
  }

  async function deleteMaterialId(materialId) {
    return await requestApi.post(`material/delete`, {
      materialId
    })
  }

  const mutationDelete = useMutation(deleteMaterialId, {
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries('materiallist')
      setIsDeleteModal(false)
      EditDataRef.current = null
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: '',
        allowOutsideClick: false,
        text: data?.meta?.message
    })
    },
    onError: (error) => {
      EditDataRef.current = null
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: '',
        allowOutsideClick: false,
        text: error?.message
    })
    }
  })

  const [openAction, setopenAction] = useState(null)
  const OpenAction = (id) => {
    setopenAction(openAction === id ? null : id);
  };

  function MaterialList({ queryKey }) {
    return requestApi.post(`material/list`, {
      limit: queryKey[2],
      page: queryKey[1],
      search: queryKey[3],
      sortKey: queryKey[4]?.sortKey,
      sortBy: queryKey[4]?.sortBy,
      status:queryKey[5]
    },
      { headers: true }
    ).then((res) => {
      return res.data
    })
  }

  const { data,isLoading } = useQuery({
    queryKey: [
      'materiallist',
      currentPage,
      DataLimit,
      searchKeyword,
      filter,
       selectedOption
    ],
    queryFn: MaterialList
  })

  useEffect(() => {
    if (currentPage && data?.data?.length == 0) {
      setCurrentPage(currentPage - 1)
    } else {
    }
  }, [currentPage, data?.data])

//#region  Table Colunms
  const columnHelper = createColumnHelper()

  const columns = [
      columnHelper.accessor((row) => row?.name, {
          id: 'name',
          header: () => 'Name',
          cell: (row) => {
            return( 
                    <span>{row?.row?.original?.name  ? row?.row?.original?.name :"-" }</span>
            )
          }
      }),
      columnHelper.accessor((row) => row?.status, {
        id: 'status',
        header: () => 'Status',
        enableSorting: false,
        cell: (row) => {
            switch (row?.row?.original?.status) {
                case 7:
                    return (
                        <span className="pending-data status-data">
                            Pending
                        </span>
                    )
                    case 5:
                        return (
                            // <span className="decline-data status-data">
                            //     Decline
                            // </span>
                            <span class="rejected-status status-data"><IconRejected/> Rejected</span>
                        )
                default:
                    return (
                        <>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={
                                        row?.row?.original?.status == 1
                                            ? true
                                            : false
                                    }
                                    onChange={(e) =>
                                        onStatusChange(
                                            row?.row?.original?._id
                                        )
                                    }
                                />
                                <span className="slider round"></span>
                            </label>
                        </>
                    )
            }
        }
    }),
    columnHelper.display({
        id: 'actions',
        header: () => 'Actions',
        cell: (row) => {
            switch (row?.row?.original?.status) {
                case 7:
                    return (
                        <>
                            {/* <div className="action-data">
                                <div
                                    className="action-icon"
                                    onClick={() => {
                                        handleApproveDecline(
                                            row?.row?.original?._id,
                                            setButtonText('Decline')
                                        )
                                    }}
                                >
                                    <DeclineIcon />
                                </div>
                                <div
                                    className="action-icon"
                                    onClick={() => {
                                        handleApproveDecline(
                                            row?.row?.original?._id,
                                            setButtonText('Approve')
                                        )
                                    }}
                                >
                                    <ApproveIcon />
                                </div>
                               
                            </div> */}
                            <div className={`table-action ${row?.row?.original?._id === openAction ? "active" : ""}`}  onMouseLeave={() => setopenAction(null)}>
                                <div className={`action-btn ${row?.row?.original?._id === openAction ? "active" : ""}`} onClick={() => OpenAction(row?.row?.original?._id)}><IconsDots/></div>
                                <div className='action-panel two-action'>
                                    <div className='action-btn-icon edit'
                                        onClick={() => {
                                            handleApproveDecline(
                                                row?.row?.original?._id,
                                                setButtonText('Approve')
                                            )
                                        }}
                                    ><IconApproveRight/></div>
                                    <div className='action-btn-icon delete'
                                        onClick={() => {
                                            handleApproveDecline(
                                                row?.row?.original?._id,
                                                setButtonText('Decline')
                                            )
                                        }}
                                    ><IconDesapproveClose/></div>
                                </div>
                            </div>
                        </>
                    )
                case 5:
                    return <>-</>
                default:
                    return (
                        <>
                            {/* <div className="action-data">
                                <div
                                    className="action-icon"
                                    onClick={() =>
                                        navigate(materialaddedit, {
                                            state: row?.row?.original?._id
                                        })
                                    }
                                >
                                    <EditIcon />
                                </div>
                                <div
                                    className="action-icon"
                                    onClick={() =>
                                        handleDeleteModal(
                                            row?.row?.original?._id
                                        )
                                    }
                                >
                                    <DeleteIcon />
                                </div>
                            </div> */}

                            <div className={`table-action ${row?.row?.original?._id === openAction ? "active" : ""}`}  onMouseLeave={() => setopenAction(null)}>
                                <div className={`action-btn ${row?.row?.original?._id === openAction ? "active" : ""}`} onClick={() => OpenAction(row?.row?.original?._id)}><IconsDots/></div>
                                <div className='action-panel two-action'>
                                    <div className='action-btn-icon edit'
                                        // onClick={() =>
                                        //     navigate(materialaddedit, {
                                        //         state: row?.row?.original?._id
                                        //     })
                                        // }
                                        onClick={() =>
                                            handleAddEditModal(
                                                row?.row?.original
                                            )
                                        }
                                    ><IconEdit/></div>
                                    {/* <div className='action-btn-icon view'><IconView/></div> */}
                                    <div className='action-btn-icon delete'
                                        onClick={() =>
                                            handleDeleteModal(
                                                row?.row?.original?._id
                                            )
                                        }
                                    ><IconDelete/></div>
                                </div>
                            </div>
                        </>
                    )
            }
        }
    })
  ]
//#endregion

  const table = useReactTable({
    data: data?.data || [],
    columns: columns,
    getSortedRowModel: getSortedRowModel(),
    getCoreRowModel: getCoreRowModel()
  })

 //#region  Approve material Process
const handleApproveDecline = (id) => {
    setShowMaterialStatusPopup(true)
    setStatusUpdate(id)
}

 function handlePermission(materialId) {
    mutationStatusUpdate.mutate(materialId)
    setShowMaterialStatusPopup(false)
  }

  async function updateStatusbyId(materialId) {

    if(buttonText=="Approve"){
        return await requestApi.post(`/material/approve-decline`, {
            materialId,
            status:1
        })
    }else{
        return await requestApi.post(`/material/approve-decline`, {
            materialId,
            status:5
        })
    } 
}
const mutationStatusUpdate = useMutation(updateStatusbyId, {
    onSuccess: ({ data }) => {
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: '',
            text: data?.meta?.message
        })
        queryClient.invalidateQueries('materiallist')
        setShowMaterialStatusPopup(false)
    },
    onError: (error) => {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: '',
            text: error?.message
        })
    }
})
//#endregion

    //#region  Active/InActive Status Update
    const onStatusChange = useCallback((materialId) => {
        mutationStatusActiveInactive.mutate(materialId)
    }, [])
    async function updateStatusbymaterialId(materialId) {
        return await requestApi.post(`/material/active-inactive-status`, {
            materialId
        })
    }

    const mutationStatusActiveInactive = useMutation(updateStatusbymaterialId, {
        onSuccess: ({ data }) => {
            // Swal.fire({
            //     position: 'center',
            //     icon: 'success',
            //     title: '',
            //     text: data?.meta?.message
            // })
            queryClient.invalidateQueries('colorlist')
            setShowMaterialStatusPopup(false)
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    //#endregion

  //#region Modal for AddEdit
  const [AddEditShow, setAddEditShow] = useState(false)
  const [materialID, setmaterialID] =useState("")

  const handleAddEditModal =(data)=>{
      setAddEditShow(true)
      const{name,_id} =data
      msetValue("materialName",name)
      setmaterialID(_id)
  }
  const handleAddEditModalForNew=()=>{
      setAddEditShow(true)
      setmaterialID(null)
      msetValue("materialName",null)
  }

  const {
      register:mregister,
      handleSubmit:mhandleSubmit,
      formState: { errors:merrors },
      setValue:msetValue
  } = useForm({  mode: "onChange",resolver: yupResolver(validationSchemaForType)})
    //#endregion

  return (
      <>
          <div className="material-management">
              <div className="admin-card">
                  <div class="head">
                      <h2>Material Management</h2>
                      <div className="search-btn-group">
                          <form
                              className="product-table-filter"
                              {...register('materialSearch', {
                                  onChange: (e) => {
                                      handleSearch(e)
                                  }
                              })}
                          >
                              <input
                                  type="search"
                                  name="materialSearch"
                                  placeholder="Search"
                              />
                          </form>
                          <div className="">
                              <StatusDropDown
                                  options={options}
                                  onSelect={handleDropdownSelect}
                                  selectedOption={selectedOption}
                              />
                          </div>
                          <button
                            //   onClick={() => navigate(materialaddedit)}
                            onClick={() =>
                                handleAddEditModalForNew()
                             }
                              className="solid-red-btn"
                          >
                              Add New Material
                          </button>
                      </div>
                  </div>
              </div>
              {isLoading ? (
                  <TableSkeleton />
              ) : data?.data?.length > 0 ? (
                  <>
                      <TableListing table={table} className="m-0" getfilter={(e) => {setFilter(e)}} />
                      <div className="pagination-wrap">
                          <div className="showing-pages">
                              <span>
                                  Showing {(currentPage - 1) * DataLimit + 1} to{' '}
                                  {Math.min(
                                      currentPage * DataLimit,
                                      data.meta.totalCount
                                  )}{' '}
                                  of {data.meta.totalCount} Materials
                              </span>
                          </div>
                          {data?.meta?.totalCount > 10 && (
                              <>
                                  {/* <div className="itemperpage-box">
                                        <span>Items per page:</span>
      
                                        <Dropdown onSelect={handleChange}>
                                            <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                            >
                                                {DataLimit}
                                            </Dropdown.Toggle>
      
                                            <Dropdown.Menu>
                                                <Dropdown.Item eventKey="10">
                                                    10
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="20">
                                                    20
                                                </Dropdown.Item>
                                                <Dropdown.Item eventKey="30">
                                                    30
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div> */}

                                  <Pagination
                                      total={Math.ceil(
                                          data.meta.totalCount / DataLimit
                                      )}
                                      current={currentPage}
                                      onChangePage={handleChangePage}
                                  />
                              </>
                          )}
                      </div>
                  </>
              ) : (
                  <div className="no-record-found">
                      <NoRecordFound />
                  </div>
              )}
              <DeleteModal
                  message={
                      <>
                          Are you sure you want to <br /> Delete this Material ?
                      </>
                  }
                  setIsDeleteModal={setIsDeleteModal}
                  isDeleteModal={isDeleteModal}
                  handleDelete={() => handleDelete(deleteId)}
              />

              <ApproveDeclinePopup
                  ShowMaterialStatusPopup={ShowMaterialStatusPopup}
                  setShowMaterialStatusPopup={setShowMaterialStatusPopup}
                  setStatusUpdate={statusUpdate}
                  title={`are you sure you want to ${buttonText} ?`}
                  // handlestatus={handlestatus}
                  text={buttonText}
                  handlePermission={() => handlePermission(statusUpdate)}
              />

              {/* AddEdit Modal Start */}
              <AddEditModal
                  AddEditShow={AddEditShow}
                  setAddEditShow={setAddEditShow}
                  handleClose={() => setAddEditShow(false)}
              >
                  <Child
                      register={mregister}
                      handleSubmit={mhandleSubmit}
                      errors={merrors}
                      setValue={msetValue}
                      materialID={materialID}
                      setmaterialID={setmaterialID}
                      setAddEditShow={setAddEditShow}
                      queryClient={queryClient}
                  />
              </AddEditModal>
              {/* AddEdit Modal End */}
          </div>
      </>
  )
}
export default MaterialManagement

//#region  Modal child Component
const Child = ({
    register,
    handleSubmit,
    errors,
    setValue,
    materialID,
    setmaterialID,
    setAddEditShow,
    queryClient,
}) => {
    const[toastshow,setToastshow] = useState(false)

    async function materialAddEditModalhandleMethod(payload) {
        if (materialID) {
            return await requestApi
                .post(`material/add-edit`, {
                    materialId: materialID,
                    ...payload
                })
                .then((res) => {
                    return res.data
                })
        } else {
            return await requestApi
                .post(`material/add-edit`, payload)
                .then((res) => {
                    return res.data
                })
        }
    }

    const mutation = useMutation(materialAddEditModalhandleMethod, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                allowOutsideClick: false,
                text: data?.meta?.message
            }).then(() => {
                setAddEditShow(false)
                setmaterialID(null)
                setValue('materialName', null)
                queryClient.invalidateQueries('materiallist')
            })             
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                allowOutsideClick: false,
                text: error?.message
            })
        }
    })

    function handleMainCategoryAddEdit(data) {
        const { materialName } = data
        try {
            mutation.mutate({ materialName })
        } catch (error) {
            console.log(error, 'Error')
        }
    }

    return (
        <div
        className=' admin-card'
            id="categorymodal001"
            name="categorymodal"
            aria-label="modal_cateogry"
        >
            <div class="head">
                <h2> {materialID ? ' Edit' : ' Add'} Material</h2>
            </div>
            <div className="admin-form-body">
                <form onSubmit={handleSubmit(handleMainCategoryAddEdit)}>
                
                        <InputControl
                            autoFocus={true}
                            label="Material Name"
                            name="materialName"
                            register={register}
                            error={errors?.materialName?.message}
                        />
                        <button type="submit" className="solid-red-btn">
                            Save
                        </button>
             
                </form>
            </div>
        </div>
    )
}
//#endregion